import { encodeFunctionData } from 'viem';
import { erc20Abi } from 'viem';
export function encodeERC20Approval(params) {
    return encodeFunctionData({
        abi: erc20Abi,
        functionName: 'approve',
        args: [params.spender, params.amount],
    });
}
